module.exports = __webpack_public_path__ + "static/media/logo.926a97cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.svg
// module id = 935
// module chunks = 31